import React, { useState } from "react";
import PropTypes from "prop-types";

import Tooltip from "core/Tooltip";
import FormTextArea from "core/FormTextArea";
import Flexbox from "core/Flexbox";
import SrOnly from "core/SrOnly";
import colors from "core/colors";
import { MaterialUIGridContainer } from "core/MaterialUI";
import {
    ReceiptInfoHelpIcon,
    PlusMinusButton,
    MinusIcon,
    ReceiptInfoTextWrapper,
    CardNumberGrid,
    MonthYearGrid,
    CvcGrid,
    NameGrid,
    PostalGrid,
    VatGrid,
    FormButtonBodyText,
    OptionalBodyText
} from "./styles";

import Add from "core/ReusableIcons/Add";

import { convertPxToRem } from "frontend/components/helpers";

const FormInputLayout = ({
    form,
    handleFormChange,
    cardNumberField,
    receiptInfo,
    mmyyField,
    cvcField,
    nameField,
    postalField
}) => {
    const [showReceiptInfoField, setShowReceiptInfoField] = useState(false);

    const handleReceiptInfoFieldChange = value => {
        handleFormChange(value, "receipt_info");
    };

    const receiptInfoField = (
        <FormTextArea
            placeholderText="Vat number, billing information (optional)"
            labelText="Vat number, billing information (optional)"
            onChange={handleFormChange && handleReceiptInfoFieldChange}
            value={form ? form.receipt_info : receiptInfo}
            isDisabled={!form}
            height={convertPxToRem({ px: 54 })}
        />
    );

    const handleVatOnclick = e => {
        e.preventDefault();
        setShowReceiptInfoField(!showReceiptInfoField);
    };

    const receiptInfoButtons = (
        <ReceiptInfoTextWrapper alignItems="flex-start">
            <FormButtonBodyText
                type="button"
                size="md"
                onClick={handleVatOnclick}
            >
                Add billing information
            </FormButtonBodyText>

            <OptionalBodyText type="span" size="md" copyColor={colors.storm}>
                (optional)
            </OptionalBodyText>

            <Tooltip message="This displays VAT, address, or job number on your invoices for tax purposes. You can change it later.">
                <ReceiptInfoHelpIcon />
            </Tooltip>
        </ReceiptInfoTextWrapper>
    );

    return (
        <MaterialUIGridContainer
            mobileMaxPadding={0}
            tabletMaxPadding={0}
            desktopMinPadding={0}
        >
            <CardNumberGrid item sm={12} md={12} lg={12}>
                {cardNumberField}
            </CardNumberGrid>

            <MonthYearGrid item>{mmyyField}</MonthYearGrid>

            <CvcGrid item>{cvcField}</CvcGrid>

            <NameGrid item sm={12} md={12} lg={12}>
                {nameField}
            </NameGrid>

            <PostalGrid item>{postalField}</PostalGrid>

            <VatGrid item sm={12} md={12} lg={12}>
                <Flexbox alignItems="flex-start">
                    <PlusMinusButton onClick={handleVatOnclick}>
                        {showReceiptInfoField ? (
                            <>
                                <MinusIcon />
                                <SrOnly>
                                    Close VAT information form field
                                </SrOnly>
                            </>
                        ) : (
                            <>
                                <Add />
                                <SrOnly>Open VAT information form field</SrOnly>
                            </>
                        )}
                    </PlusMinusButton>

                    {showReceiptInfoField
                        ? receiptInfoField
                        : receiptInfoButtons}
                </Flexbox>
            </VatGrid>
        </MaterialUIGridContainer>
    );
};

FormInputLayout.propTypes = {
    form: PropTypes.object,
    handleFormChange: PropTypes.func,
    receiptInfo: PropTypes.string,
    cardNumberField: PropTypes.element.isRequired,
    mmyyField: PropTypes.element.isRequired,
    cvcField: PropTypes.element.isRequired,
    nameField: PropTypes.element.isRequired,
    postalField: PropTypes.element.isRequired
};

export default FormInputLayout;
